import { defineStore } from 'pinia'
import api from '@/my/modules/auth/api/sessions.api'

export const useSessionStore = defineStore('session', () => {
  async function sendMagicLink(tempValueId: string, code: string): Promise<SendMagicLinkResponse> {
    return await api.sendMagicLink(tempValueId, code)
  }

  async function verifyMagicLink(
    token: string,
    code: string,
    tempId: string
  ): Promise<VerifyMagicLinkResponse> {
    return await api.verifyMagicLink(token, code, tempId)
  }

  async function ping(): Promise<PingResponse> {
    return await api.ping()
  }

  async function getPasskeyChallenge() {
    return await api.getPasskeyChallenge()
  }

  async function verifyPasskey(data: SignInPasskeyRequest) {
    return await api.verifyPasskey(data)
  }

  async function signInWithAuthenticator(
    code: string,
    temp: string
  ): Promise<SignInAuthenticatorResponse> {
    return await api.signInWithAuthenticator({ code, temp })
  }

  return {
    ping,
    sendMagicLink,
    verifyMagicLink,
    getPasskeyChallenge,
    verifyPasskey,
    signInWithAuthenticator
  }
})
